module.exports = __webpack_public_path__ + "img/IMG_9996.e0bc52ea.jpg";